const _excluded = ["value", "onChange"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { companyNameValidation, nameValidation, requiredValidation, titleValidation } from 'validators';
import { AnimatedTextField, Button, MenuItem, Select, TextField, Typography } from 'seagull';
import { CheckboxWithLabel } from 'seagull/components/MultiSelectFilterPicker/CheckboxWithLabel';
import { Close12 } from 'seagull/icons';
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { useOnMount } from "../../../hooks/useOnMount";
import { BusinessIndustryType } from "../../../store/store.model";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { StepTemplate } from "../StepTemplate";
import { useQboInVob } from "../useQboInVob";
import { Step } from "../VendorOnboardingModal.utils";
import styles from "./FirstStep.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const numOfInvoicesOptions = [{
  label: 'Less than 10',
  value: '0'
}, {
  label: '10-50',
  value: '10'
}, {
  label: '50-250',
  value: '50'
}, {
  label: '250-1000',
  value: '250'
}, {
  label: 'More than 1000',
  value: '1000'
}];
const businessIndustryTypesOptions = [BusinessIndustryType.Bookkeeping, BusinessIndustryType.Accounting, BusinessIndustryType.TaxPreparation, BusinessIndustryType.TaxRepresentation, BusinessIndustryType.TaxResolution, BusinessIndustryType.Marketing, BusinessIndustryType.Other];
const businessIndustryTypeToLabel = {
  [BusinessIndustryType.Bookkeeping]: 'Bookkeeping',
  [BusinessIndustryType.Accounting]: 'Accounting',
  [BusinessIndustryType.TaxPreparation]: 'Tax Preparation',
  [BusinessIndustryType.TaxRepresentation]: 'Tax Representation',
  [BusinessIndustryType.TaxResolution]: 'Tax Resolution',
  [BusinessIndustryType.Marketing]: 'Marketing',
  [BusinessIndustryType.Other]: 'Other'
};
const firstNameValidator = nameValidation(undefined, {
  required: 'Please enter a first name'
});
const lastNameValidator = nameValidation(undefined, {
  required: 'Please enter a last name'
});
const companyNameValidator = companyNameValidation(undefined, {
  required: 'Please enter a company name'
});
const businessIndustryTypeValidator = {
  validate: val => val.length > 0 || 'Please select an industry'
};
const numOfInvoicesValidator = requiredValidation('Please enter number of invoices');
const BUSINESS_DESCRIPTION_SUGGESTIONS = ['Bookkeeping firm', 'Tax advisory', 'Marketing agency', 'Consulting services', 'Accounting practice'];
const Section = props => /*#__PURE__*/_jsxs("div", {
  className: styles.section,
  children: [/*#__PURE__*/_jsx(Typography, {
    children: props.title
  }), props.children]
});
export function FirstStep(props) {
  const {
    initialState,
    onSubmit
  } = props;
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    getFieldState
  } = useForm({
    mode: 'onChange',
    defaultValues: initialState
  });
  const {
    BUSINESS_DESCRIPTION_ONBOARDING
  } = useFeatureFlags();
  const watchBusinessTypes = watch('businessTypes');
  const [showNameSection, setShowNameSection] = useState(true);
  const {
    showQboStep
  } = useQboInVob();
  useOnMount(() => {
    trigger(['name']).then(() => {
      setShowNameSection(getFieldState('name').invalid);
    });
  });
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handleSubmit(onSubmit),
    children: /*#__PURE__*/_jsx(StepTemplate, {
      currentStep: Step.First,
      stepper: "Step 1 of ".concat(showQboStep ? '3' : '2'),
      header: "Let's get you started",
      subHeader: "Tell us about your business so we can customize your account to fit your needs",
      footer: /*#__PURE__*/_jsx(Button, {
        testId: "vob-step-".concat(Step.First, "-submit"),
        type: "submit",
        className: styles.submitBtn,
        children: "Next"
      }),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.root,
        children: [showNameSection && /*#__PURE__*/_jsxs("div", {
          className: styles.nameSection,
          children: [/*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "name.first",
            rules: firstNameValidator,
            render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
              collapseHelperText: false
            }, connectControllerToTextField(renderProps)), {}, {
              testId: "vob-first-name",
              placeholder: "First name"
            }))
          }), /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "name.last",
            rules: lastNameValidator,
            render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
              collapseHelperText: false
            }, connectControllerToTextField(renderProps)), {}, {
              testId: "vob-last-name",
              placeholder: "Last name"
            }))
          })]
        }), /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: "companyName",
          rules: companyNameValidator,
          render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
            collapseHelperText: false
          }, connectControllerToTextField(renderProps)), {}, {
            testId: "vob-company-name",
            placeholder: "Company name"
          }))
        }), BUSINESS_DESCRIPTION_ONBOARDING ? /*#__PURE__*/_jsx(Section, {
          title: "How would you describe your business?",
          children: /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "businessDescription",
            rules: {
              required: 'Please describe your business',
              minLength: {
                value: 10,
                message: 'Please provide at least 10 characters'
              }
            },
            render: renderProps => {
              const connected = connectControllerToTextField(renderProps);
              return /*#__PURE__*/_jsx(AnimatedTextField, {
                suggestions: BUSINESS_DESCRIPTION_SUGGESTIONS,
                staticPrefix: "E.g. ",
                collapseHelperText: true,
                helperText: connected.helperText || "We'll use this to select the right templates for your account",
                error: connected.error,
                value: connected.value,
                onChange: connected.onChange,
                onBlur: connected.onBlur,
                inputRef: connected.inputRef,
                testId: "vob-business-description"
              });
            }
          })
        }) : /*#__PURE__*/_jsx(Section, {
          title: "What services do you provide?",
          children: watchBusinessTypes.includes(BusinessIndustryType.Other) && watchBusinessTypes.length === 1 ? /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "businessTypeOther",
            rules: titleValidation('Service'),
            render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
              collapseHelperText: false
            }, connectControllerToTextField(renderProps)), {}, {
              testId: "vob-business-type-other",
              placeholder: "Write your own (optional)",
              autoFocus: true,
              suffix: /*#__PURE__*/_jsx("span", {
                className: styles.removeOther,
                onClick: () => {
                  setValue('businessTypeOther', undefined);
                  setValue('businessTypes', []);
                },
                "data-testid": "vob-business-type-other-remove",
                children: /*#__PURE__*/_jsx(Close12, {})
              })
            }))
          }, "other") : /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "businessTypes",
            rules: businessIndustryTypeValidator,
            render: renderProps => {
              const _connectControllerToT = connectControllerToTextField(renderProps),
                {
                  value,
                  onChange: _onChange
                } = _connectControllerToT,
                rest = _objectWithoutProperties(_connectControllerToT, _excluded);
              const displayValue = value.map(businessIndustryType => businessIndustryTypeToLabel[businessIndustryType]).join(', ');
              return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
                collapseHelperText: false
              }, rest), {}, {
                testId: "vob-business-type",
                placeholder: "Select",
                value: value,
                SelectProps: {
                  multiple: true
                },
                displayValue: displayValue,
                children: businessIndustryTypesOptions.map(optionValue => /*#__PURE__*/_jsx(CheckboxWithLabel, {
                  label: businessIndustryTypeToLabel[optionValue],
                  checked: value.includes(optionValue),
                  onChange: e => {
                    _onChange(e.target.checked ? value.concat([optionValue]) : value.filter(item => item !== optionValue));
                  },
                  className: styles.businessTypeOption,
                  testId: "bt-option-".concat(optionValue)
                }, optionValue))
              }));
            }
          })
        }), /*#__PURE__*/_jsx(Section, {
          title: "How many invoices do you issue a month?",
          children: /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "numOfInvoices",
            rules: numOfInvoicesValidator,
            render: renderProps => /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
              collapseHelperText: false
            }, connectControllerToTextField(renderProps)), {}, {
              testId: "vob-num-of-invoices",
              placeholder: "Select",
              children: numOfInvoicesOptions.map(_ref => {
                let {
                  label,
                  value
                } = _ref;
                return /*#__PURE__*/_jsx(MenuItem, {
                  value: value,
                  testId: "noi-option-".concat(value),
                  children: label
                }, value);
              })
            }))
          })
        })]
      })
    })
  });
}